import { i18n } from '@avanta/shared/i18n';

export type I18nServiceTypes = {
  changeLanguage: (language: string) => void;
};

export const i18nService: I18nServiceTypes = {
  changeLanguage: (language: string) => {
    i18n.changeLanguage(language);
  },
};
